import { Grid } from '@mui/material';
import useStore from '../zustand/useStore';
import StatementCard from './StatementCard';

function renderStyleifPublished(){
  const tags = document.getElementsByClassName("ituMainNav") //search class in itu wordpress theme
 
  if (tags.length > 0) {
    // contains.
    return "ituContainer grid fullWidthCards" //class for wordpress
  }
  else
  return "card-view" //class in standalone react

}

const CardView = () => {
  const { cards } = useStore((state) => ({ cards: state.MUIdata.rows }));
  const { datasource } = useStore((state) => ({ datasource: state.settings.params.datasource }));

  return (
    <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
      <Grid item xs={12}>
        <div className={renderStyleifPublished()}>
          {
            cards.length>0 ?
            ( 
          cards.map((card, i) => {
            return <StatementCard key={i} data={card} datasource={datasource}  />;
          })
            )
          :
          (
            <p>No sessions</p>
          
          )
          }
        </div>
      </Grid>
    </Grid>
  );
};

export default CardView;
